import { render, staticRenderFns } from "./InvoiceHistoryTable.vue?vue&type=template&id=395def06"
import script from "./InvoiceHistoryTable.vue?vue&type=script&lang=js"
export * from "./InvoiceHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports